import { render, staticRenderFns } from "./app-document-ready.vue?vue&type=template&id=5d1e20fa&"
import script from "./app-document-ready.vue?vue&type=script&lang=js&"
export * from "./app-document-ready.vue?vue&type=script&lang=js&"
import style0 from "./app-document-ready.vue?vue&type=style&index=0&id=5d1e20fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports